import ConfigsList from './ConfigsList';

export default ConfigsList;
